import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { CollapseModule } from "ngx-bootstrap/collapse";
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { MenuItemComponent } from './layout/menu-item/menu-item.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from './shared/shared.module';
import { InterceptorProviders } from './core/interceptors/interceptors';

import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import { PaginatorModule } from 'primeng/paginator';

import { MsalModule, MsalRedirectComponent,   MsalGuard,
  MsalInterceptor } from "@azure/msal-angular";
import { TranslateLoader, TranslateService, provideTranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader, provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpLoaderFactory } from './core/languages/translate';
import { FileUploadModule } from 'primeng/fileupload';
import { ZoneInterceptor } from './core/interceptors/zone.interceptor';
import { SkeletonModule } from 'primeng/skeleton';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';


const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

const msalConfig = environment.mslConfig;

@NgModule({
  declarations: [
    ContentLayoutComponent,
    SidebarComponent,
    MenuItemComponent,
    AppComponent,
  ],
  imports: [
    SharedModule,
    ToastModule,
    PaginatorModule,
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    FileUploadModule,
    SkeletonModule,
    CollapseModule,
    HttpClientModule,
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 4000,
      progressBar: true,
      preventDuplicates: true
    }),

    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: msalConfig.clientId,
          authority: msalConfig.authority,
          redirectUri: msalConfig.redirectUri,
          postLogoutRedirectUri:  msalConfig.redirectUri,
          
        },
        cache: {
          cacheLocation: "localStorage",
          
        },
      }),
      {
        interactionType: InteractionType.Redirect, // Msal Guard Configuration
        authRequest: {
          scopes: [environment.scope],
        },
      },
      {
        interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
        protectedResourceMap: new Map([
          [ `${environment.security}${environment.host}/*` , [environment.scope]]
        ]),
      }
    ),

  ],

  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    provideTranslateService({
      loader: {
          provide: TranslateLoader,
          useClass: TranslateHttpLoader
      }
    }),
    provideTranslateHttpLoader(),
    providePrimeNG({
        theme: {
            preset: Lara,
            options: {
                darkModeSelector: '.dark-theme'
            }
        }
    }),
    MsalGuard,
    InterceptorProviders,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ZoneInterceptor,
      multi: true,
    },
    MessageService,
    ConfirmationService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
